import _ from 'lodash';
import React, { useContext, useEffect, useMemo, useReducer } from "react";
import { useAppUserAccess } from "global/cnr/contexts/useHelpers/useAppUserAccess";
import { ParentContext } from "../../../../global/cnr/contexts/ParentContext";
import { sportsRtMatchHandlers, sportsRtMatchInitialState, sportsRtMatchReducer } from "../reducers/SportsRtMatchReducer";
import { SeasonMatchesContext } from "./SeasonMatchesContext";
import { SportsMatchContext } from "./SportsMatchContext";
import { SportsSeasonContext } from "./SportsSeasonContext";

export const SportsRtMatchContext = React.createContext()

export default function SportsRtMatchProvider(props) {

  const { match } = props

  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { app_state, appUser_state, paps_state } = states ?? {}
  const { mainRt } = app_state ?? {}
  const { appUsers } = appUser_state ?? {}
  const { pathViews } = paps_state ?? {}
  const appUserAccess = useAppUserAccess()
  const appUserInfo = appUserAccess ? { displayName: appUserAccess.displayName, uid: appUserAccess.uid } : {}

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { matches_info, latestSeason, _sportData, sportPermissions, sportDataSettings } = sportsSeason_state ?? {}
  const { matches_realtime } = matches_info ?? {}

  // seasonMatchesContext
  const seasonMatchesContext = useContext(SeasonMatchesContext)
  const componentContexts = { sportsSeasonContext, seasonMatchesContext }

  // sportsMatchContext
  const sportsMatchContext = useContext(SportsMatchContext)
  const { sportsMatch_state } = sportsMatchContext ?? {}
  const { gameScoringType } = sportsMatch_state ?? {}

  const init_state = { mainRt, sportDataSettings, sportPermissions, _sportData, latestSeason, appUserInfo, pathViews, gameScoringType }
  const [sportsRtMatch_state, sportsMatchRealtime_dispatch] = useReducer(sportsRtMatchReducer, init_state, sportsRtMatchInitialState)
  const sportsRtMatch_handlers = sportsRtMatchHandlers(sportsMatchRealtime_dispatch, sportsRtMatch_state)

  const rtMatch = useMemo(() => {
    return match ? matches_realtime?.[match._itemKey] : null;
  }, [matches_realtime, match?._itemKey]);

  useEffect(() => {
    if (match && rtMatch) {
      sportsRtMatch_handlers.handleSet_rtMatch(match, rtMatch);
    }
  }, [match, rtMatch]);

  return <SportsRtMatchContext.Provider value={{ sportsRtMatch_state, sportsRtMatch_handlers, componentContexts }}>
    {props.children}
  </SportsRtMatchContext.Provider>
}